import DashboardBanners from './DashboardBanners'

export default DashboardBanners
